<section class="entity-association-attribute-search">
  <p class="categories-loading" *ngIf="categoriesLoading">
    Loading store attribute filters...
  </p>

  <p class="categories-load-error" *ngIf="!categoriesLoading && categoriesLoadError">
    Could not load store attribute filters. Please refresh and try again.
  </p>

  <ng-container *ngIf="!categoriesLoading && !categoriesLoadError && hasStoreAttributes">
    <div class="filter-panel" [formGroup]="filterForm">
      <h4 class="filter-panel__title">Filter by Inherited Store Attributes</h4>

      <div *ngFor="let category of categories" class="filter-section">
        <div class="filter-section-label">
          <span class="dot" [ngClass]="getCategoryDotClass(category.color)"></span>
          {{ category.name }}
        </div>

        <div *ngIf="categoryUsesOnlySelects(category)" class="filter-row">
          <div *ngFor="let field of category.fields" class="filter-group">
            <label>{{ getFilterFieldDisplayName(field) }}</label>
            <select [formControl]="getControl(field.clientKey)">
              <option [ngValue]="null">All {{ getFilterFieldDisplayName(field) }}</option>
              <option *ngFor="let option of getSelectOptions(field)" [ngValue]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>

        <div *ngIf="categoryUsesOnlyMultiSelects(category)" class="filter-row">
          <div *ngFor="let field of category.fields" class="filter-group">
            <label>{{ getFilterFieldDisplayName(field) }}</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
              <mat-select [formControl]="getControl(field.clientKey)" multiple>
                <mat-option *ngFor="let option of field.options" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="!categoryUsesOnlySelects(category) && !categoryUsesOnlyMultiSelects(category) && categoryUsesOnlyBooleans(category)" class="filter-checkboxes">
          <label *ngFor="let field of category.fields" class="filter-check">
            <input type="checkbox" [formControl]="getControl(field.clientKey)" />
            {{ field.name }}
          </label>
        </div>

        <div *ngIf="!categoryUsesOnlySelects(category) && !categoryUsesOnlyMultiSelects(category) && !categoryUsesOnlyBooleans(category)" class="filter-row filter-row--mixed">
          <ng-container *ngFor="let field of category.fields">
            <div *ngIf="field.valueType === singleSelectType" class="filter-group">
              <label>{{ getFilterFieldDisplayName(field) }}</label>
              <select [formControl]="getControl(field.clientKey)">
                <option [ngValue]="null">All {{ getFilterFieldDisplayName(field) }}</option>
                <option *ngFor="let option of getSelectOptions(field)" [ngValue]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div *ngIf="field.valueType === multiSelectType" class="filter-group">
              <label>{{ getFilterFieldDisplayName(field) }}</label>
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
                <mat-select [formControl]="getControl(field.clientKey)" multiple>
                  <mat-option *ngFor="let option of field.options" [value]="option">
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <label *ngIf="field.valueType === booleanType" class="filter-check">
              <input type="checkbox" [formControl]="getControl(field.clientKey)" />
              {{ field.name }}
            </label>
            <div *ngIf="field.valueType === textType" class="filter-group">
              <label>{{ getFilterFieldDisplayName(field) }}</label>
              <input type="text" [formControl]="getControl(field.clientKey)" />
            </div>
          </ng-container>
        </div>
      </div>

      <div class="filter-active-tags">
        <span class="filter-results-count" *ngIf="hasAppliedFilters">
          {{ searchSummary.matchingVersions }} versions match
        </span>
        <span class="filter-results-count" *ngIf="!hasAppliedFilters && hasActiveFilters">
          {{ activeSelections.length }} filter{{ activeSelections.length === 1 ? '' : 's' }} selected
        </span>
        <span class="filter-results-count" *ngIf="!canSearch">
          Enter a version code or select store attribute filters, then click Search
        </span>
        <span class="filter-active-tags__sep" *ngIf="canSearch">|</span>
        <span
          *ngFor="let selection of activeSelections"
          class="filter-tag-removable"
          [ngClass]="getCategoryTagClass(selection.categoryColor)">
          {{ selection.label }}: {{ selection.displayValue }}
          <span class="x" (click)="removeFilter(selection.clientKey)">x</span>
        </span>
        <button type="button" class="btn btn-sm btn-primary filter-btn" [disabled]="!canSearch" (click)="applyFilters()">
          Search
        </button>
        <button type="button" class="btn btn-sm btn-outline clear-all-btn-vl" (click)="clearAll()">
          Clear All
        </button>
      </div>
    </div>

    <!-- <div class="stats-row" *ngIf="hasAppliedFilters">
      <div class="stat-card">
        <div class="stat-value">{{ searchSummary.matchingVersions }}</div>
        <div class="stat-label">Matching Versions</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ searchSummary.fullMatch }}</div>
        <div class="stat-label">Full Match</div>
      </div>
      <div class="stat-card">
        <div class="stat-value stat-value--warning">{{ searchSummary.partialMatch }}</div>
        <div class="stat-label">Partial Match</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ searchSummary.totalStores }}</div>
        <div class="stat-label">Total Stores</div>
      </div>
    </div> -->

    <div class="bulk-select-row" *ngIf="hasAppliedFilters && !attributeSearchLoading && apiResults.length">
      <label class="bulk-select-row__full">
        <input
          type="checkbox"
          [checked]="allFullMatchesSelected"
          [indeterminate]="someFullMatchesSelected"
          (change)="onSelectAllFullMatchesChange($any($event.target).checked)" />
        <strong *ngIf="hasAppliedAttributeFilters">Select all {{ searchSummary.fullMatch }} full matches</strong>
        <strong *ngIf="!hasAppliedAttributeFilters">Select all {{ searchSummary.matchingVersions }} versions</strong>
      </label>
      <label class="bulk-select-row__partial" *ngIf="searchSummary.partialMatch">
        <input
          type="checkbox"
          [checked]="includePartialMatches"
          (change)="onIncludePartialMatchesChange($any($event.target).checked)" />
        Include {{ searchSummary.partialMatch }} partial matches
      </label>
    </div>

    <div class="card results-card" *ngIf="hasAppliedFilters">
      <div class="card-header">
        <span>{{ filteredResultsTitle }}</span>
        <span class="card-header__sort" *ngIf="hasAppliedAttributeFilters">Sorted: full matches first</span>
      </div>

      <p class="results-loading" *ngIf="attributeSearchLoading">Loading matching versions...</p>

      <ng-container *ngIf="!attributeSearchLoading">
        <p class="no-results-message" *ngIf="apiResults.length === 0">
          No versions match the selected filters.
        </p>

        <div
          *ngFor="let result of fullMatchResults"
          class="version-item"
          [class.version-item--selected]="isVersionSelected(result.versionName)"
          (click)="onVersionCheckboxChange(result, !isVersionSelected(result.versionName))">
          <div class="version-checkbox" [class.version-checkbox--checked]="isVersionSelected(result.versionName)">
            <span *ngIf="isVersionSelected(result.versionName)">&#10003;</span>
          </div>
          <div
            *ngIf="hasAppliedAttributeFilters"
            class="conflict-icon conflict-ok"
            [matTooltip]="getMatchTooltip(result)"
            matTooltipPosition="above">
            &#10003;
          </div>
          <div class="version-code">{{ result.versionName }}</div>
          <div class="version-tags">
            <span
              *ngFor="let tag of result.inheritedAttributes"
              class="tag"
              [ngClass]="getTagClass(tag.categoryColorHex)">
              {{ formatTagLabel(tag) }}
            </span>
          </div>
          <div class="version-meta">
            {{ result.storeCount }} stores
          </div>
        </div>

        <ng-container *ngIf="hasAppliedAttributeFilters">
        <div class="partial-matches-banner" *ngIf="partialMatchResults.length">
          &#9888; Partial Matches - cross-state or mixed-capability versions
        </div>

        <ng-container *ngFor="let result of partialMatchResults">
          <div
            class="version-item version-item--partial"
            [class.version-item--selected]="isVersionSelected(result.versionName)"
            [class.version-item--disabled]="!isRowSelectable(result)"
            (click)="onVersionCheckboxChange(result, !isVersionSelected(result.versionName))">
            <div
              class="version-checkbox"
              [class.version-checkbox--checked]="isVersionSelected(result.versionName)"
              [class.version-checkbox--disabled]="!isRowSelectable(result)">
              <span *ngIf="isVersionSelected(result.versionName)">&#10003;</span>
            </div>
            <div
              class="conflict-icon conflict-warn conflict-warn--clickable"
              [matTooltip]="getMatchTooltip(result)"
              matTooltipPosition="above"
              (click)="toggleConflictDetail(result, $event)">
              !
            </div>
            <div class="version-code">{{ result.versionName }}</div>
            <div class="version-tags">
              <span
                *ngFor="let tag of result.inheritedAttributes"
                class="tag"
                [ngClass]="getTagClass(tag.categoryColorHex)">
                {{ formatTagLabel(tag) }}
              </span>
            </div>
            <div class="version-meta">
              {{ result.storeCount }} stores<br />
              <span class="version-meta__match version-meta__match--partial">{{ result.matchPercent }}% match</span>
            </div>
          </div>

          <app-version-conflict-detail-panel
            *ngIf="isConflictDetailExpanded(result) && eventId"
            [eventId]="eventId"
            [versionId]="result.versionId!"
            [versionName]="result.versionName"
            [appliedFilters]="appliedSelections"
            [filterPairs]="appliedFilterPairs"
            [showActions]="true"
            (excludeVersion)="onConflictExclude(result)"
            (includeAnyway)="onConflictIncludeAnyway(result)">
          </app-version-conflict-detail-panel>
        </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="!categoriesLoading && !hasStoreAttributes">
    <div class="simple-mode-grid" *ngIf="hasAppliedFilters">
      <p class="results-loading" *ngIf="attributeSearchLoading">Loading versions...</p>

      <div class="grid-container" *ngIf="!attributeSearchLoading">
        <table *ngIf="apiResults.length" mat-table [dataSource]="apiResults" class="simple-versions-table">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="no-ellipsis">
              <mat-checkbox
                (change)="$event ? onSimpleModeMasterToggle() : null"
                [checked]="isAllSimpleModeSelected()"
                [indeterminate]="someSimpleModeSelected()"
                [disabled]="!apiResults.length">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let result" class="no-ellipsis">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="onVersionCheckboxChange(result, $event.checked)"
                [checked]="isVersionSelected(result.versionName)">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="versionName">
            <th mat-header-cell *matHeaderCellDef>Version Name</th>
            <td mat-cell *matCellDef="let result">{{ result.versionName }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="simpleDisplayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: simpleDisplayedColumns"></tr>
        </table>

        <table *ngIf="!apiResults.length">
          <tr>
            <td class="no-records" colspan="2"><h2>No Records Found</h2></td>
          </tr>
        </table>
      </div>

      <mat-paginator
        class="results-paginator"
        *ngIf="!attributeSearchLoading && apiTotal > 0"
        [length]="apiTotal"
        [pageSize]="page.pageSize"
        [pageIndex]="page.pageIndex"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 500]"
        showFirstLastButtons
        (page)="onPage($event)">
      </mat-paginator>
    </div>
  </ng-container>
</section>
